import PropTypes from "prop-types";
import React, { Component } from "react";
import { Helmet } from 'react-helmet'

class PageHelmet extends Component {
    render() {
        const { pageTitle, description, keywords } = this.props;
        const metaDescription =
            description ||
            'Na Chansawang Farmstay Yasothon – organic farm, camping near me and authentic Isaan food near me with hikes nearby.';
        const metaKeywords =
            keywords ||
            'Na Chansawang, farmstay, camping, organic farm, Isaan food near me, camping near me, hikes near me';
        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{pageTitle} | {this.props.siteName || 'Na Chansawang Farmstay Yasothon'}</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <meta property="og:image" content="/assets/images/logo/logo.png" />
                    <meta name="description" content={metaDescription} />
                    <meta name="keywords" content={metaKeywords} />
                    <meta name="author" content="Chansawang Farmstay" />
                </Helmet>
            </React.Fragment>
        )
    }
}
PageHelmet.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
};
export default PageHelmet;
